import { formatPrice } from '@moda/portal-stanchions';
import { getDiscountedPrice } from '../../lib/variantUtils/getDiscountedPrice';
import { CartPrice } from '../useCart';

interface VATOnProductPrice {
  currency: string;
  human: string;
  price: number | string;
}

export const useLineItemPrices = (
  currentSinglePrice: CartPrice,
  quantity: number,
  originalPrice: CartPrice,
  markdownPercentage: number,
  VATOnProductPrice: VATOnProductPrice,
  showPriceWithVAT: boolean | undefined,
  promotionApplicableMessage: string | null,
  isItemPriceDiscounted: boolean
) => {
  const currentPrice = {
    ...currentSinglePrice,
    price: quantity * Number(currentSinglePrice.price)
  };

  const discountedPrice = getDiscountedPrice(
    Number(
      isItemPriceDiscounted ? originalPrice.price : quantity * Number(currentSinglePrice.price)
    ),
    markdownPercentage
  );

  const originalPriceWithVAT = {
    ...originalPrice,
    price: Number(originalPrice.price) + Number(VATOnProductPrice.price)
  };

  const discountedPriceWithVAT = {
    ...originalPrice,
    price: Number(discountedPrice) + Number(VATOnProductPrice.price)
  };

  const originalPriceToShow = formatPrice(
    originalPrice.currency,
    showPriceWithVAT ? originalPriceWithVAT.price : originalPrice.price
  );
  const currentPriceToShow = formatPrice(
    originalPrice.currency,
    showPriceWithVAT ? discountedPriceWithVAT.price : discountedPrice
  );

  const promoApplied =
    promotionApplicableMessage && promotionApplicableMessage.toLowerCase() === 'promo applied';

  return {
    promoApplied,
    discountedPrice,
    originalPriceToShow,
    currentPriceToShow,
    originalPriceWithVAT,
    currentPrice
  };
};
